"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageBoardlist = void 0;
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var crumbs_1 = require("../crumbs");
var layout_1 = require("./shared/layout");
var mini_time_chart_1 = require("./shared/mini_time_chart");
var hotlinks_1 = require("../quotetable/hotlinks");
var quotetable_1 = require("../quotetable");
var bk_1 = require("../../modules/quote/bk");
var min_zjl_chart_1 = require("./shared/min_zjl_chart");
var title_quotetable_1 = require("./shared/title/title_quotetable");
var morezb_1 = require("../quotetable/morezb");
require("./boardlist.less");
// 板块三个首页
var bkhome = ['#concept_board', '#region_board', '#industry_board', '#industry_board_1', '#industry_board_2', '#industry_board_3'];
/**
 * 沪深京板块-二级三级通用
 */
function PageBoardlist() {
    var location = (0, react_router_dom_1.useLocation)();
    var hash = location.hash;
    return (react_1.default.createElement("div", { className: "boards_cont" },
        bkhome.indexOf(hash) > -1 &&
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(crumbs_1.CrumbsWithRefreshLine, null),
                (hash == '#concept_board' || hash == '#region_board' || hash == '#industry_board') &&
                    react_1.default.createElement("div", { className: "hlmzb scf" },
                        react_1.default.createElement("div", { className: "hl" },
                            hash == '#concept_board' &&
                                react_1.default.createElement(hotlinks_1.BK_GNHotLinks, null),
                            hash == '#region_board' &&
                                react_1.default.createElement(hotlinks_1.BK_DYHotLinks, null),
                            hash == '#industry_board' &&
                                react_1.default.createElement(hotlinks_1.BK_HYHotLinks, null))),
                react_1.default.createElement(quotetable_1.QuoteTable, null)),
        bkhome.indexOf(hash) < 0 &&
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(SingleBK, null))));
}
exports.PageBoardlist = PageBoardlist;
/**
 * 自定义指标
 */
var custom_quote = [
    { title: '市净率', value: '市净率', sort: true },
    { title: '净利润', value: '净利润', sort: true },
    { title: '总市值', value: '总市值', sort: true },
    { title: '流通市值', value: '流通市值', sort: true },
    { title: '60日涨跌幅', value: '涨跌幅_60日', sort: true },
    { title: '年初至今涨跌幅', value: '年初至今涨跌幅', sort: true },
    { title: '涨速', value: '涨速_3分钟', sort: true },
    { title: '5分钟涨跌', value: '涨跌幅_5分钟', sort: true }
];
/**
 * 单个板块模块
 */
function SingleBK() {
    var _this = this;
    var _a = (0, react_1.useState)(""), bkname = _a[0], setName = _a[1];
    var _b = (0, react_1.useState)(custom_quote[0]), showzb = _b[0], SetShowZB = _b[1]; //选择的指标
    var _c = (0, react_1.useState)(0), onIndex = _c[0], setOnIndex = _c[1];
    var location = (0, react_router_dom_1.useLocation)();
    var hash = location.hash;
    if (!/^#boards2\-90\.(bk|BK)\d+$/.test(hash)) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    var bkcode = hash.split("-")[1];
    var code = bkcode.split(".")[1]; // bk0917
    // if(code.length == 5) {
    //   code = "BK0" + code.replace(/bk/i, ''); // 补全位数
    //   self.location.hash = "#boards2-90." + code
    // }
    (0, react_1.useEffect)(function () {
        ;
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var name;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, bk_1.getBKname)(bkcode)];
                    case 1:
                        name = _a.sent();
                        setName(name);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [hash]);
    var changeSelectIndex = function (index) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                SetShowZB(custom_quote[index]);
                setOnIndex(index);
                return [2 /*return*/];
            });
        });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(crumbs_1.BoardCrumbsWithRefreshLine, { bkname: bkname }),
        react_1.default.createElement(layout_1.Layout3, { mt: 0 },
            react_1.default.createElement(layout_1.Layout3.Item, null,
                react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: bkcode, height: 162, width: 324, link: true, border: false },
                    bkname,
                    "\u884C\u60C5")),
            react_1.default.createElement(layout_1.Layout3.Item, null,
                react_1.default.createElement(min_zjl_chart_1.Title1MiniZJLChart, { bkcode: bkcode, height: 162, width: 324, link: true, border: false },
                    bkname,
                    "\u8D44\u91D1\u6D41\u5411")),
            react_1.default.createElement(layout_1.Layout3.Item, null,
                react_1.default.createElement("div", { className: "ph_table" },
                    react_1.default.createElement(title_quotetable_1.Title1QuoteTable, { table_key: 'ZJLPH',
                        fs: 'b:' + code,
                        count: 5,
                        order: 'f62',
                        orderdur: 1 },
                        react_1.default.createElement("a", { href: "https://data.eastmoney.com/bkzj/".concat(code, ".html"), target: "_blank" },
                            bkname,
                            "\u4E2A\u80A1\u8D44\u91D1\u6D41\u5411\u6392\u884C"))))),
        react_1.default.createElement("div", { className: "mzb" },
            react_1.default.createElement(morezb_1.MoreZB, { data: custom_quote, onIndex: onIndex, onChange: changeSelectIndex })),
        react_1.default.createElement(quotetable_1.QuoteTable, { custom_item: showzb, mt: 10 })));
}
